import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { ListBillets } from '@/core/domain/financial/Boletos/Boletos.types';
import { Col, Form, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';

export interface GenerateRemittanceFormValues {
  companyId: number;
}

type Props = Omit<ModalProps, 'onCancel'> & {
  companyId?: number;
  onCancel: () => void;
  selectedBankSlip?: ListBillets;
  onCallback: (values: GenerateRemittanceFormValues) => void;
  loading?: boolean;
};

export default function BankSlipGenerateRemittanceModal({
  companyId,
  open,
  onCancel,
  onCallback,
  loading,
}: Props) {
  const [form] = Form.useForm<GenerateRemittanceFormValues>();

  useEffect(() => {
    if (companyId) {
      form.setFieldValue('companyId', companyId);
    }
  }, [open]);

  const handleOk = async () => {
    await onCallback(await form.validateFields());

    form.resetFields();
  };

  return (
    <Modal
      width={400}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      title="Geração do Arquivo Remessa"
      cancelText="Cancelar"
      okText="Gerar"
      okButtonProps={{ loading }}
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem label="Empresa" name="companyId">
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
